import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "px-4 sm:px-6 lg:px-8 flex flex-row gap-4" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "flex space-x-4" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentUser)
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 0,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLocationId) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
              return (_openBlock(), _createElementBlock("option", {
                value: location.id,
                key: location.id,
                class: "py-4 text-sm font-semibold"
              }, _toDisplayString(location.companyName), 9, _hoisted_3))
            }), 128))
          ], 512)), [
            [_vModelSelect, _ctx.selectedLocationId]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNavItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.path,
            class: "py-4 text-sm font-semibold"
          }, [
            (item.path && (item.condition ? item.condition() : true))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: item.path,
                  class: _normalizeClass(_ctx.routeClass(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"]))
              : _createCommentVNode("", true),
            (item.action)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: ($event: any) => (item.action && item.action()),
                  href: "javascript:void(0)",
                  class: _normalizeClass(_ctx.routeClass(item))
                }, _toDisplayString(item.name), 11, _hoisted_5))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}